import { useAuthStore } from '@/state/authStore';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

/** Renders children only for admins. UX gate; backend remains the
 *  authoritative role enforcer. */
export function AdminOnly({ children, fallback = null }: Props) {
  const isAdmin = useAuthStore((s) => s.isAdmin());
  return <>{isAdmin ? children : fallback}</>;
}
